/**
 * Override default FiltersForm behavior to prevent form submission
 * This should be loaded after theme.js to properly override the behavior
 */

function overrideFormSubmit() {
  const filterForm = document.querySelector('[data-collection-filters-form]');
  
  if (filterForm) {
    // Store original submit method in case we need it
    if (!filterForm._originalSubmit && filterForm.submit) {
      filterForm._originalSubmit = filterForm.submit;
    }
    
    // Override submit to do nothing (AJAX handler will take care of updates)
    filterForm.submit = function() {
      // Trigger custom event instead of submitting
      this.dispatchEvent(new CustomEvent('filters:submit:prevented', {
        bubbles: true,
        detail: { form: this }
      }));
      return false;
    };
  }
}

// Try to override immediately and after DOM content loaded
document.addEventListener('DOMContentLoaded', function() {
  overrideFormSubmit();
  
  // Also try after a short delay to ensure theme.js has initialized
  setTimeout(overrideFormSubmit, 100);
  setTimeout(overrideFormSubmit, 500);
});

// Also handle theme editor section reloads
document.addEventListener('shopify:section:load', function() {
  setTimeout(overrideFormSubmit, 100);
});